// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"a23f7a71","321":"504dd4e2","873":"67243032","960":"3f3d93a2","966":"da34735a"}[chunkId] + ".chunk.css";
};